import styled from "styled-components";
import { FONT_SIZE } from "@/config/theme/constants";

interface IconWrapperProps {
  $isOnlyTitle: boolean;
}

export const IconWrapper = styled.div<IconWrapperProps>`
  font-size: ${(props) =>
    props.$isOnlyTitle ? FONT_SIZE.xxxxl : FONT_SIZE.xxxxxl};
  line-height: 2rem;
`;

export const EmptyDescription = styled.div`
  margin-top: -0.75rem;
`;
